import { render, staticRenderFns } from "./add-existing-profile-card.vue?vue&type=template&id=2ef3a5f5&scoped=true&"
import script from "./add-existing-profile-card.vue?vue&type=script&lang=js&"
export * from "./add-existing-profile-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef3a5f5",
  null
  
)

export default component.exports